// import particlesPackage from 'particles.js/particles';
import { $qs, $qsa } from '../../utils/QuerySelector';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import SplitText from 'gsap/SplitText';

gsap.registerPlugin(ScrollTrigger, SplitText);

// import * as THREE from 'three';
// import fragment from "../../utils/fragment.glsl";
// import vertex from "../../utils/vertex.glsl";

import { Scene, PerspectiveCamera, Raycaster, Vector2, MeshBasicMaterial, RingGeometry, Mesh, WebGLRenderer, LineBasicMaterial } from 'three';
// import {Perlin, FBM} from 'three-noise';


function clamp(number, min, max) {
    return Math.max(min, Math.min(number, max));
  }

function bannerHome() {

  const renderer = new WebGLRenderer( { antialias: true, alpha: true } );
  let animationPlay = false;

  document.fonts.ready.then(function () {
  
  loadingLogo();   

  scrollingToSection();
  })

  webGLCircles();
  sectorsAnimation();

  function sectorsAnimation(){

    const homeSector = $qsa('[data-name="home-sector"]');
    const homeSectorTitle = $qs('[data-name="home-sector-title"]');
    const homeSectorButton = $qs('[data-name="home-sector-button"]');
    const homeSectorTeasers = $qsa('[data-name="home-sector-teaser"]');

    if (!homeSectorTeasers) return;

    
    const homeSectorTitleSplit = new SplitText(homeSectorTitle, {type: "chars, words", wordsClass: "word", charsClass: "char"});

    const timeline = gsap.timeline();

    timeline
    .from(homeSectorTitleSplit.chars, {opacity: 0, stagger: '0.01'})
    .from(homeSectorButton, {opacity: 0 })
    .from(homeSectorTeasers, {opacity: 0, duration:0.6, stagger: 0.2})

        ScrollTrigger.create({
            trigger: homeSector,
            start: 'top 70%',
            animation: timeline,
            markers: false
        })
}


function loadingLogo(){

  const loadingLogo = $qs('[data-name="loading-logo"]');
  if (!loadingLogo) return;

  const timeline = gsap.timeline();

  const loadingAnimation = $qs('[data-name="loading-animation"]');
  const leftCircle = $qs('[data-name="loading-left-circle"]',loadingLogo);
  const rightCircle = $qs('[data-name="loading-right-circle"]',loadingLogo);
  const companyName = $qs('[data-name="company-name"]',loadingLogo);
  const loadingBg = $qs('[data-name="loading-bg"]');
  const expandingRing = $qs('[data-name="expanding-ring"]');
  const bannerRings = $qs('[data-name="webgl-rings"]');
  const bannerRingsCurtain = $qs('[data-name="webgl-rings-curtain"]');

  
  const bannerTitle = $qs('[data-name="banner-home-title"]');
  const bannerP = $qs('[data-name="banner-home-p"]');
  const bannerPLine = $qs('[data-name="banner-home-p-line"]');

  const splitBannerTitle = new SplitText(bannerTitle, {type: "chars, words", wordsClass: "word", charsClass: "char"});
  // const lines = splitBannerTitle.lines;
  const chars = splitBannerTitle.chars;

  gsap.set(loadingLogo, {opacity: 1})
  var hasPlayed = sessionStorage.getItem("hasLoadingPlayed");
  if (!hasPlayed) {
  timeline
  .from(leftCircle,{x: '230%', opacity: 0, duration: 1.3,ease: "power2.inOut"}, "start")
  .from(rightCircle,{x: '-230%', opacity: 0, duration: 1.3, ease: "power2.inOut"}, "start")
  .from(companyName,{y: '50px', duration: .8, ease: "power2.inOut"}, "start+=.5")
  .addLabel('part2')
  .to(leftCircle,{x: '8px', fill: '#fff', duration: .3,ease: "power2.inOut"}, "part2+=1")
  .to(rightCircle,{x: '-8px', fill: '#fff', duration: .3, ease: "power2.inOut"}, "part2+=1")
  .to(companyName,{y: '-120px', duration: 0.4, ease: "power2.in"}, "part2+=1.3")

  .addLabel('part3')
  // .to(loadingBg, {opacity: 0, duration: 0.6}, "part3")
  .set(leftCircle, {opacity: 0}, "part3")
  .set(rightCircle, {opacity: 0}, "part3" )
  // .set(expandingRing, {opacity: 1}, "part3" )
  .addLabel('zoom')

  // .to(expandingRing, {scale: 15, opacity: 0, transformOrigin: 'center center', duration: 1}, "zoom")
  // .from(bannerRings, {scale: 0.2, opacity: 0, transformOrigin: 'center center', duration: 1}, "zoom")
  // .from(bannerRings, { opacity: 0, duration: 1}, "zoom")
  .to(expandingRing,{opacity:0, duration: 0.5}, "zoom")
  .add(function() { animationPlay = true; }, "zoom")
  .to(bannerRings, {filter: "blur(5px)", duration: 0.5},"zoom")
  .to(bannerRingsCurtain, {opacity: "0", duration: 0.3},"zoom")
  .to(loadingAnimation, {autoAlpha: 0, pointerEvents: "none"},"zoom")
  .addLabel('bannerContent')
  .from(bannerP, {opacity: 0}, 'bannerContent')
  .from(bannerPLine, {scaleX: 0, transformOrigin: 'left'}, 'bannerContent')
  // .from(bannerTitle, {opacity: 0, y: '20px', stagger: '0.01'}, 'bannerContent')
  .from(chars, {opacity: 0, stagger: '0.01'}, 'bannerContent')
  sessionStorage.setItem("hasLoadingPlayed", true);
  } else {
    timeline
    .addLabel('zoom')
    .to(expandingRing,{opacity:0, duration: 0.5}, "zoom")
    .add(function() { animationPlay = true; }, "zoom")
    .to(bannerRings, {filter: "blur(5px)", duration: 0.5},"zoom")
    .to(bannerRingsCurtain, {opacity: "0", duration: 0.3},"zoom")
    .to(loadingAnimation, {autoAlpha: 0, pointerEvents: "none"},"zoom")
    .addLabel('bannerContent')
    .from(bannerP, {opacity: 0}, 'bannerContent')
    .from(bannerPLine, {scaleX: 0, transformOrigin: 'left'}, 'bannerContent')
    // .from(bannerTitle, {opacity: 0, y: '20px', stagger: '0.01'}, 'bannerContent')
    .from(chars, {opacity: 0, stagger: '0.01'}, 'bannerContent')

  }

}

function scrollingToSection(){
  const bannerHome = $qs('[data-name="banner-home"]');
  const bannerBG = $qs('[data-name="banner-bg"]');
  const bannerRings = $qs('[data-name="webgl-rings"]');
  const bannerCurtain = $qs('[data-name="banner-curtain"]');
  const collidingCircles = $qs('[data-name="colliding-circles-home"]');
  const ccTitle = $qs('[data-name="cch-title"]');
  const ccButton = $qs('[data-name="cch-button"]');
  const ccContent = $qs('[data-name="cch-content"]');

  const height = window.innerHeight;

  let pinned = true;
  if(window.innerWidth < 1024) pinned = false;

 if(!bannerHome) return;
 let secondSectionTLPIN = false;
 let secondSectionTLSCRUB = true;
 let secondSectionTLSTART = 'top bottom';
 if(pinned){ secondSectionTLPIN = collidingCircles; secondSectionTLSCRUB = true; secondSectionTLSTART = 'top top';  }
  const secondSectionTL = gsap.timeline({
    ease: 'none',
    scrollTrigger: {
        trigger: collidingCircles,
        pin: secondSectionTLPIN,
        pinSpacing: true,
        start: secondSectionTLSTART,
        end: height + 'px top',
        // endTrigger: collidingCircles,

        scrub: secondSectionTLSCRUB,
        markers: false
    },
});

let bannerHomePIN = false;
if(pinned) bannerHomePIN = bannerHome

  const bannerTL = gsap.timeline({
    ease: 'none',
    scrollTrigger: {
        trigger: bannerHome,
        pin: bannerHomePIN,
        pinSpacing: false,
        start: 'top top',
        end: height + 'px top',

        scrub: true,
        markers: false
    },
});

if($qs('[data-name="colliding-circles-home"]')){
let pinLogo = ScrollTrigger.create({
  trigger: "body",
  pin: '[data-pin="top-logo"]',
  pinSpacing: false,
  start: "top top",
  end: "top top",
  endTrigger: '[data-name="home-deals"]',
  markers: false,
  
 
});


}



bannerTL
.to(bannerCurtain, {autoAlpha: 1}, 'start')
.to(bannerBG, {scale: 1.6, ease: "power1.in"}, 'start')
.fromTo(bannerRings, {scale: 1},{scale: 1.6, ease: "power1.in"}, 'start')
if(pinned) bannerTL.set(bannerHome, {autoAlpha: 0, duration: 0.01})


// const splitSSTitle = new SplitText(ccTitle, {type: "chars, lines", linesClass: "line", charsClass: "char"});
// const lines = splitSSTitle.lines;
// const chars = splitSSTitle.chars;

if(pinned){
secondSectionTL
.from($qs('[data-name="left-circle"]',collidingCircles),{opacity: '0', duration: 0.1}, "start")
.from($qs('[data-name="right-circle"]',collidingCircles),{opacity: '0', duration: 0.1}, "start")
.to($qs('[data-name="left-circle"]',collidingCircles),{x: '30%'}, "start")
.to($qs('[data-name="right-circle"]',collidingCircles),{x: '-30%'}, "start")
.from(ccTitle, {opacity: 0, y: '20px', stagger: '0.005', duration: '0.1'}, "start")
.from(ccButton,{opacity: 0, y: '10px'}, "start")
.from(ccContent,{opacity: 0}, "start")
}else{
  secondSectionTL.from($qs('[data-name="left-circle"]',collidingCircles),{opacity: '0', duration: 0.1}, "start")
.from($qs('[data-name="right-circle"]',collidingCircles),{opacity: '0', duration: 0.1}, "start")
.to($qs('[data-name="left-circle"]',collidingCircles),{x: '30%'}, "start")
.to($qs('[data-name="right-circle"]',collidingCircles),{x: '-30%'}, "start")

}
}

function webGLCircles(){


  const webGLRingsCanvas = $qs('[data-name="webgl-rings"]');
  if(!webGLRingsCanvas) return

  const canvas = webGLRingsCanvas;
  const innerdia = 0.60
  const ringThickness = 0.1

  const ringWidth1 = innerdia - ringThickness
  const ringWidth2 = innerdia * 2
  const mouseThreshold = 0.2;


  
  


const camera = new PerspectiveCamera( 100, window.innerWidth / window.innerHeight, 0.01, 10 );

// WORK OUT INITIAL ZOOM VALUE
const initialZoom = 12;
camera.position.z = initialZoom;

const scene = new Scene();

const raycaster = new Raycaster();
const pointer = new Vector2();
// scene.background = new Color( 0xff0000, 0 );
const material = new MeshBasicMaterial( {color: 0x00468b,  wireframe: false, opacity:0,  transparent: true});
const whitematerial = new MeshBasicMaterial( {color: 0xffffff, opacity: 1, transparent: true, wireframe: false});
const material2 = new MeshBasicMaterial( {color: 0x0046ff, wireframe: true});

const ringDetail = 64;

const ring1 = new RingGeometry( ringWidth1, ringWidth1 + 0.01, ringDetail ); 
const ring1Mouse = new RingGeometry( ringWidth1 - mouseThreshold, ringWidth1 + ringThickness+ mouseThreshold, 64, 2 ); 

const ring2 = new RingGeometry( ringWidth2, ringWidth2 + ringThickness, ringDetail ); 
const ring2Mouse = new RingGeometry( ringWidth2 - mouseThreshold, ringWidth2 + ringThickness+ mouseThreshold, 64, 2 ); 

const whiteRing = new RingGeometry( ringWidth1, ringWidth2, ringDetail ); 


// geometry.deleteAttribute('normal')
// geometry = BufferGeometryUtils.mergeVertices(geometry)
// geometry.computeVertexNormals()

// rgb(0, 70, 139)

const meshRing1 = new Mesh( ring1, material );
meshRing1.geometry.computeVertexNormals();
scene.add( meshRing1 );
const meshRing2 = new Mesh( ring2, material );
scene.add( meshRing2 );
const meshWhiteRing = new Mesh( whiteRing, whitematerial );
scene.add( meshWhiteRing );


const meshRing1Mouse = new Mesh( ring1Mouse, material2 );
meshRing1Mouse.geometry.computeVertexNormals();
const meshRing2Mouse = new Mesh( ring2Mouse, material2 );
meshRing2Mouse.geometry.computeVertexNormals();
// scene.add( meshRing1Mouse );
// scene.add( meshRing2Mouse );

renderer.setSize( window.innerWidth, window.innerHeight + 35 );
renderer.setClearColor( 0xffffff, 0 );
renderer.setAnimationLoop( animation );
webGLRingsCanvas.appendChild( renderer.domElement );

const baseMeshPoints = [...meshRing1.geometry.attributes.position.array];

const halfVertices = (baseMeshPoints.length) / 2;
const thirdVertices = (baseMeshPoints.length) / 3;
const meshPoints = baseMeshPoints.length - 3
// -2 maybe?
// console.info(halfVertices);
// console.info(thirdVertices);

const speedModifier = 300;
const pointDifference = 0.8;
const maxThickness = 0.025; //max thickness
const minThickness = 0.005;


window.addEventListener( 'pointermove', onPointerMove );

function onPointerMove( event ) {

	pointer.x = ( event.clientX / window.innerWidth ) * 2 - 1;
	pointer.y = - ( event.clientY / window.innerHeight ) * 2 + 1;

}



const center = new Vector2( 0, 0 );

const lineMaterial = new LineBasicMaterial( { color: 0x00ff00 } );

const arrayPointsStart = [];
const indexRandomiser = [];



meshRing1.geometry.attributes.position.array.forEach((element,index) => {
  if(index % 3 == 0 && index < halfVertices){

    let vector = new Vector2(meshRing1.geometry.attributes.position.array[ index ],meshRing1.geometry.attributes.position.array[ index+1 ]);
    arrayPointsStart.push(vector);
    let rand = Math.floor(Math.random() * (80 - 20 + 1) + 20) / 100;
    indexRandomiser.push(rand);
  }
})

const arrayPointsStart2 = [];

meshRing2.geometry.attributes.position.array.forEach((element,index) => {
  if(index % 3 == 0 && index < halfVertices){

    let vector = new Vector2(meshRing2.geometry.attributes.position.array[ index ],meshRing2.geometry.attributes.position.array[ index+1 ]);
    arrayPointsStart2.push(vector);
    
  }
})


let mouseTime = 0;

function morphRing(ring){

}


// assuming fps is 60 - need to reduce from 6 in 1 second
function animation( time ) {
  if(!animationPlay) return

// if(camera.position.z > 1) camera.position.z -= 0.1;
if(camera.position.z == initialZoom){
   gsap.to(camera.position, {z: 1, ease: "power3.out", duration: 0.8})
   gsap.to(meshWhiteRing.material, {opacity: 0.1, ease: "power3.out", duration:0.5});
}
// if(meshWhiteRing.material.opacity > 0.1 && camera.position.z <= 3) meshWhiteRing.material.opacity -= 0.02;

// if(meshRing1.material.opacity < 1 && camera.position.z <= 1 && meshWhiteRing.material.opacity <= 0.2) meshRing1.material.opacity += 0.005;
if(meshRing2.material.opacity < 0.45 && camera.position.z <= 1 && meshWhiteRing.material.opacity <= 0.2) meshRing2.material.opacity += 0.01;

  raycaster.setFromCamera( pointer, camera );
	const intersects = raycaster.intersectObjects( [meshRing1Mouse, meshRing2Mouse] );
let mouseFace = null;
let mouseFace2 = null;

	for ( let i = 0; i < intersects.length; i ++ ) {
		// intersects[ i ].object.material.color.set( 0xff0000 );
    // console.info(intersects[ i ])
    const index = intersects[ i ].faceIndex;  
    index = Math.floor(index % 128 / 2);
    //having these hardcoded may break hover effect
    if(intersects[ i ].object.id == 13) mouseFace = index;
    if(intersects[ i ].object.id == 14) mouseFace2 = index;
    if(mouseTime < 1.5) mouseTime += 0.1;
    // console.info('raycast1:' + mouseFace);
    // console.info('raycast2:' + mouseFace2);
	}

  if(!intersects.length){
    if(mouseTime > 0) mouseTime -= 0.1;

  }

  // console.info(fbm.get2(new Vector2(time/noiseSpeed)));
  // Update points based on distance to center

  arrayPointsStart.forEach((element,index) => {
  
      // GET VECTOR DIRECTION AS WIDTH AND APPLY TO BOTH THE X AND THE Y
    //  let rand = Math.floor(Math.random() * (51 - 49 + 1) + 49) / 10;
    //index randomiser
    
    //rotation speed changes every 4 seconds
    let rotationSpeed = Math.cos(time / 4);
   rotationSpeed += 1;
   rotationSpeed * 3;
  //  if(index == 1) console.info(speedModifier - rotationSpeed);
   rotationSpeed = 0;

    let timeFunction = ((Math.sin(time/(speedModifier - rotationSpeed) + (index + indexRandomiser[index]) * pointDifference)));
    let innertimeFunction = ((Math.sin(time/(speedModifier - rotationSpeed) + (index + indexRandomiser[index]) * 0.45)));
    // console.info(distance);
    timeFunction = timeFunction + 1;
    let distance = timeFunction * maxThickness;
    innertimeFunction = innertimeFunction + 1;
    let innerDistance = innertimeFunction * maxThickness/2;
    // let distance = ((fbm.get2(new Vector2((time/noiseSpeed + index), 0)    ))) * 10 + 0.02;
    // fbm._scale += 0.0001;
    // console.info(fbm);

    let maxThicknessInner = maxThickness;

    //increase a multuplier array with gsap?
    if(index == mouseFace || index + 1 == mouseFace || index - 1 == mouseFace || index + 2 == mouseFace || index - 2 == mouseFace || index + 3 == mouseFace || index - 3 == mouseFace){
      maxThicknessInner = maxThickness * 3;
    }
    if(index == mouseFace)innerDistance = Math.abs(innerDistance) * 2 * mouseTime; 
    //check if either side of mouseface
    if(index + 1 == mouseFace || index - 1 == mouseFace) innerDistance = Math.abs(innerDistance) * 1.6 * mouseTime;
    if(index + 2 == mouseFace || index - 2 == mouseFace) innerDistance = Math.abs(innerDistance) * 1.4 * mouseTime;
    if(index + 3 == mouseFace || index - 3 == mouseFace) innerDistance = Math.abs(innerDistance) * mouseTime;

    // Do we set a target for each point and then they just move towards that at a steady rate?

    // console.info(width);
    let xIndex = index * 3;
    let yIndex = xIndex + 1;
    let xIndexOuter = xIndex + halfVertices;
    let yIndexOuter = xIndex + halfVertices + 1;

    if(index == ringDetail){
    index = 0;
    element = arrayPointsStart[index];
    }
    // Do we need to normalise?
    // element = element.normalize();
    // console.info(element);
    // Find angle
    let angle = (Math.atan(element.y / element.x)) ;
    // find hypothen
    let hyp = Math.sqrt((element.x * element.x) + (element.y * element.y));
    // console.info(hyp);
    // new hyp lenth
    let outerHyp = hyp + innerDistance;
    hyp -= innerDistance;
    // if(index == 1) console.info(hyp)

    if(hyp > ringWidth1 - minThickness){
      hyp = ringWidth1 - minThickness
    }
    if(outerHyp < ringWidth1 + minThickness){
      outerHyp = ringWidth1 + minThickness
    }
    // if(hyp < 1 - maxThicknessInner){
    //   hyp = 1 - maxThicknessInner
    // }
    // if(outerHyp > 1 + maxThicknessInner){
    //   outerHyp = 1 + maxThicknessInner
    // }

    // new x - adjacent length
    let newX = hyp * Math.cos(angle);
    let newY = hyp * Math.sin(angle);


    // I think in addition to making the angle an absolute value, could you add a check on whether the original x value is < 0 and if so, make the new x value also < 0? and same with y

    if(index > ringDetail/4 && index <= ringDetail - ringDetail/4){
      newX = newX * -1;
      newY = newY * -1;
    } 

    // change both sides the same
    // let newOuterX = outerHyp * Math.cos(angle);
    // let newOuterY = outerHyp * Math.sin(angle);

    //fix negative values
    // if(index > 16 && index < 49){
    //   newOuterX = newOuterX * -1;
    //   newOuterY = newOuterY * -1;
    // }

    // JUST CHANGE DIFFERENCE FROM INNER AND OUTER ON MOUSE HOVER
    
    // VARY THICKNESS A BIT
    // let newOuterX = newX + maxThickness * distance;
    // let newOuterY = newY + maxThickness * distance;
    let thicknessChange = maxThickness;
    thicknessChange = thicknessChange + (timeFunction/100);

    const outerCood = calculateOuterRing(newX, newY, thicknessChange, index,ringDetail );

    // x coordinate inner
    meshRing1.geometry.attributes.position.array[ xIndex ] = newX;
    // y coordinate inner
    meshRing1.geometry.attributes.position.array[ yIndex ] = newY;
    // // y coordinate outer
    // meshRing1.geometry.attributes.position.array[xIndexOuter] = outerCood[0] ;
    // // y coordinate outer 
    // meshRing1.geometry.attributes.position.array[yIndexOuter] = outerCood[1] ;
  
  })
  

  // RING 2

  arrayPointsStart2.forEach((element,index) => {
  let rotationSpeed = Math.cos(time / 4);
 rotationSpeed += 1;
 rotationSpeed * 3;
//  if(index == 1) console.info(speedModifier - rotationSpeed);
 rotationSpeed = 0;

  let timeFunction = ((Math.sin(time/(speedModifier - rotationSpeed) + (index + indexRandomiser[index]) * pointDifference)));
  timeFunction = timeFunction + 1;
  let distance = timeFunction * maxThickness;


  // ADD MOUSEFACE2 FOR RING 2
  let maxThicknessInner = maxThickness;

  //increase a multuplier array with gsap?
  if(index == mouseFace2 || index + 1 == mouseFace2 || index - 1 == mouseFace2 || index + 2 == mouseFace2 || index - 2 == mouseFace2 || index + 3 == mouseFace2 || index - 3 == mouseFace2){
    maxThicknessInner = maxThickness * 3;
  }
  if(index == mouseFace2)distance = Math.abs(distance) * 2 * mouseTime; 
  //check if either side of mouseface
  if(index + 1 == mouseFace2 || index - 1 == mouseFace2) distance = Math.abs(distance) * 1.6 * mouseTime;
  if(index + 2 == mouseFace2 || index - 2 == mouseFace2) distance = Math.abs(distance) * 1.4 * mouseTime;
  if(index + 3 == mouseFace2 || index - 3 == mouseFace2) distance = Math.abs(distance) * mouseTime;

  let xIndex = index * 3;
  let yIndex = xIndex + 1;
  let xIndexOuter = xIndex + halfVertices;
  let yIndexOuter = xIndex + halfVertices + 1;

  if(index == ringDetail){
    index = 0;
    element = arrayPointsStart2[index];
    }

  let angle = (Math.atan(element.y / element.x)) ;
  let hyp = Math.sqrt((element.x * element.x) + (element.y * element.y));

  let outerHyp = hyp + distance;
  hyp -= distance;

  if(hyp > ringWidth2 - minThickness){
    hyp = ringWidth2 - minThickness
  }
  if(outerHyp < ringWidth2 + minThickness){
    outerHyp = ringWidth2 + minThickness
  }

  let newX = hyp * Math.cos(angle);
  let newY = hyp * Math.sin(angle);

  if(index > ringDetail/4 && index <= ringDetail - ringDetail/4){
    newX = newX * -1;
    newY = newY * -1;
  } 

  let thicknessChange = maxThickness;
  thicknessChange = thicknessChange + (timeFunction/100);

  const outerCood = calculateOuterRing(newX, newY, thicknessChange, index,ringDetail );

  // x coordinate inner
  // meshRing2.geometry.attributes.position.array[ xIndex ] = newX;
  // y coordinate inner
  // meshRing2.geometry.attributes.position.array[ yIndex ] = newY;
  // // y coordinate outer
  meshRing2.geometry.attributes.position.array[xIndexOuter] = outerCood[0] ;
  // // y coordinate outer 
  meshRing2.geometry.attributes.position.array[yIndexOuter] = outerCood[1] ;

})

function calculateOuterRing(x,y,thickness,index,ringDetail){
  let newOuterX = x + thickness;
  let newOuterY = y + thickness;

  if(index > ringDetail/4 && index <= ringDetail - ringDetail/4){    
    newOuterX = x - thickness;
    newOuterY = y - thickness;
  }

  if(index > ringDetail/4 && index <= ringDetail - ringDetail/2){    
    newOuterX = x - thickness;
    newOuterY = y + thickness;
  }
  if(index > ringDetail/2 + ringDetail/4  && index <= ringDetail){    
    newOuterX = x + thickness;
    newOuterY = y - thickness;
  }
  return [newOuterX,newOuterY]
}

//how to pause and start animation? DONE

//fade blue lines in DONE

//chaneg camera rather than scaling canvas DONE

//fix top left and bottom right gaps

//add mouse interactivity to outside ring DONE

//make width correct of ring - the whole is double the width DONE

  //rotate ring? will affect mouse interactions
  meshRing1.geometry.attributes.position.needsUpdate = true;
  meshRing2.geometry.attributes.position.needsUpdate = true;
  camera.position.needsUpdate = true;

	renderer.render( scene, camera );

}
}
}


export default bannerHome;